import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';

// Employee Pages
import EmployeeHome from './pages/Employee/EmployeeHome';
import VacancyList from './pages/Employee/VacancyList';
import VacancyDetail from './pages/Employee/VacancyDetail';
import ApplyVacancy from './pages/Employee/ApplyVacancy';
import Applications from './pages/Employee/Applications';
import SavedVacancies from './pages/Employee/SavedVacancies';
import Profile from './pages/Employee/Profile';
import Settings from './pages/Employee/Settings';
import EditProfile from './pages/Employee/EditProfile';
import CourseDetail from './pages/Employee/CourseDetail';
import VideoLesson from './pages/Employee/VideoLesson';
import CoursesList from './pages/Employee/CoursesList';
import Notifications from './pages/Employee/Notifications';

// Company Pages
import CompanyVacancyManagement from './pages/Company/VacancyManagement';
import CompanyVacancyDetail from './pages/Company/VacancyDetail';
import CompanyVacancyApplications from './pages/Company/VacancyApplications';
import CreateVacancy from './pages/Company/CreateVacancy';
import EditVacancy from './pages/Company/EditVacancy';
import Plans from './pages/Company/Plans';
import CompanyProfile from './pages/Company/Profile';
import CompanySettings from './pages/Company/Settings';
import CompanyEditProfile from './pages/Company/EditProfile';
import CompanySubscriptions from './pages/Company/Subscriptions';
import CompanySubscriptionDetail from './pages/Company/SubscriptionDetail';
import CompanyUsers from './pages/Company/Users';
import CompanyUserCreate from './pages/Company/UserCreate';
import CompanyUserEdit from './pages/Company/UserEdit';
import CompanyEditUserProfile from './pages/Company/EditUserProfile';
import CompanyNotifications from './pages/Company/Notifications';
import CompanyViewEmployeeProfile from './pages/Company/ViewEmployeeProfile';

// Recruitment Company Pages
import RecruitmentCompanyVacancyManagement from './pages/RecruitmentCompany/VacancyManagement';
import RecruitmentCompanySubscriptions from './pages/RecruitmentCompany/Subscriptions';
import RecruitmentCompanyPlans from './pages/RecruitmentCompany/Plans';
import RecruitmentCompanyProfile from './pages/RecruitmentCompany/Profile';
import RecruitmentCompanyCreateVacancy from './pages/RecruitmentCompany/CreateVacancy';
import RecruitmentCompanyVacancyDetail from './pages/RecruitmentCompany/VacancyDetail';
import RecruitmentCompanyVacancyApplications from './pages/RecruitmentCompany/VacancyApplications';
import RecruitmentCompanyEditVacancy from './pages/RecruitmentCompany/EditVacancy';
import RecruitmentCompanyEditProfile from './pages/RecruitmentCompany/EditProfile';
import RecruitmentCompanySettings from './pages/RecruitmentCompany/Settings';
import RecruitmentCompanyNotifications from './pages/RecruitmentCompany/Notifications';
import RecruitmentCompanyViewEmployeeProfile from './pages/RecruitmentCompany/ViewEmployeeProfile';

// Components
import PrivateRoute from './components/PrivateRoute';
import RoleBasedRoute from './components/RoleBasedRoute';
import RoleBasedRedirect from './components/RoleBasedRedirect';
import Navbar from './components/Navbar';

// Styles
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <Navbar />
                <main className="main-content">
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />

                        {/* Employee Routes */}
                        <Route
                            path="/employee/home"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <EmployeeHome />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/vacancies"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <VacancyList />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/vacancies/:id"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <VacancyDetail />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/vacancies/:id/apply"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <ApplyVacancy />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/applications"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <Applications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/saved"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <SavedVacancies />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/profile"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <Profile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/settings"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <Settings />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/notifications"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <Notifications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/edit-profile"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <EditProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/courses"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <CoursesList />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/courses/:id"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <CourseDetail />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/employee/courses/:courseId/videos/:videoId"
                            element={
                                <RoleBasedRoute allowedRoles={['employee', 'admin']}>
                                    <VideoLesson />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            }
                        />

                        {/* Company Routes */}
                        <Route
                            path="/company/notifications"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyNotifications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/settings"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanySettings />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/edit-profile"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyEditProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/profile"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/subscriptions"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanySubscriptions />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/subscriptions/:id"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanySubscriptionDetail />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/users"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyUsers />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/users/create"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyUserCreate />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/users/:userId/edit"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyUserEdit />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/settings/edit-user"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyEditUserProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/plans"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <Plans />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/vacancies"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'recruitment_company', 'admin']}>
                                    <CompanyVacancyManagement />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/vacancies/create"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'recruitment_company', 'admin']}>
                                    <CreateVacancy />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/vacancies/:id/applications"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'recruitment_company', 'admin']}>
                                    <CompanyVacancyApplications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/vacancies/:id"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'recruitment_company', 'admin']}>
                                    <CompanyVacancyDetail />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/vacancies/:id/edit"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'recruitment_company', 'admin']}>
                                    <EditVacancy />
                                </RoleBasedRoute>
                            }
                        />

                        {/* Recruitment Company Routes */}
                        <Route
                            path="/recruitment-company/vacancies"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyVacancyManagement />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/vacancies/create"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyCreateVacancy />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/vacancies/:id"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyVacancyDetail />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/vacancies/:id/edit"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyEditVacancy />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/vacancies/:id/applications"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyVacancyApplications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/subscriptions"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanySubscriptions />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/plans"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyPlans />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/profile"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/edit-profile"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyEditProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/settings"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanySettings />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/notifications"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyNotifications />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/company/employees/:employeeId"
                            element={
                                <RoleBasedRoute allowedRoles={['company', 'admin']}>
                                    <CompanyViewEmployeeProfile />
                                </RoleBasedRoute>
                            }
                        />
                        <Route
                            path="/recruitment-company/employees/:employeeId"
                            element={
                                <RoleBasedRoute allowedRoles={['recruitment_company', 'admin']}>
                                    <RecruitmentCompanyViewEmployeeProfile />
                                </RoleBasedRoute>
                            }
                        />

                        <Route
                            path="/"
                            element={
                                <PrivateRoute>
                                    <RoleBasedRedirect />
                                </PrivateRoute>
                            }
                        />
                    </Routes>
                </main>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </Router>
    );
}

export default App;

